import { Button, List, ListItem, ListItemText, Typography } from '@mui/material';
import React from 'react';

import { describeSeparateOutputOutcome, SeparateOutputOutcome } from 'services/export/useSeparateOutputExports';

interface SeparateOutputsStatusProps {
  outputs: { id: string; title: string }[];
  outcomes: Record<string, SeparateOutputOutcome>;
  canRetry: boolean;
  onRetry: () => void;
}

export const SeparateOutputsStatus: React.FC<SeparateOutputsStatusProps> = ({
  outputs,
  outcomes,
  canRetry,
  onRetry,
}) => {
  const reported = outputs.filter((output) => outcomes[output.id]);
  if (reported.length === 0) return null;
  return (
    <div role="status" aria-live="polite">
      <Typography component="h3" variant="subtitle1" sx={{ mb: 0.5 }}>
        Export outcomes
      </Typography>
      <List dense disablePadding>
        {reported.map((output) => (
          <ListItem key={output.id} disableGutters>
            <ListItemText primary={output.title} secondary={describeSeparateOutputOutcome(outcomes[output.id])} />
          </ListItem>
        ))}
      </List>
      {canRetry && (
        <Button size="small" color="secondary" variant="outlined" onClick={onRetry}>
          Retry failed outputs
        </Button>
      )}
    </div>
  );
};
